import * as amplitude from "@amplitude/analytics-browser";

import _ from "lodash";

import { useAuthStore } from "../store/useAuthStore";
import { logGAEvent } from "../GAanalytics";

export const trackEvent = (eventname: string, metaData?: any) => {
  const email = useAuthStore.getState().email || metaData?.email;
  const name = useAuthStore.getState().name || metaData?.name;
  const userMetaData = {
    name: name,
    email: email,
    ...metaData,
  };
  amplitude.setUserId(email);
  // logGAEvent("user_interaction", "button_click", eventname);
  amplitude.track(eventname, userMetaData);
};
